import React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { GameLoader, GamesWrapper } from 'src/domains/layouts/shared/loaders';
import { observer } from 'src/utils/mobx-react';

export const CasinoGamesLoader = observer('CasinoGamesLoader', () => {
    const games = [];
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    for (let i = 0; i < 16; i++) {
        games.push(
            <GameLoader
                key={i}
                variant={configState.componentVariants.casinoVariant}
            />
        );
    }

    return <GamesWrapper>{games}</GamesWrapper>;
});
